module.exports = __webpack_public_path__ + "assets/img/00081.503fcc15.png";